import { jsx as _jsx } from "react/jsx-runtime";
import { useContentfulPage } from "../../context/ContentfulPageContext";
import { DEVICE_TYPES } from "../../styling/consts";
import { responsiveClasses } from "../../styling/helpers";
import React from "react";
const CONTAINER_TYPE_KEYS = {
    // CAROUSEL: 'Carousel',
    GRID: "Grid",
    ROW: "Row",
};
const VARIABLE_TYPE_KEYS = {
    COLUMNS: "Columns",
};
const TAILWIND = {
    [CONTAINER_TYPE_KEYS.GRID]: "grid",
    [VARIABLE_TYPE_KEYS.COLUMNS]: "grid-cols-",
    [CONTAINER_TYPE_KEYS.ROW]: "flex flex-row",
};
export const Container = ({ children, containerType, mobileContainerType, sectionId }) => {
    const { getContentBlockStyles } = useContentfulPage();
    const contentBlockStyles = sectionId ? getContentBlockStyles(sectionId) : {};
    const legacyClasses = legacyContainerClasses(mobileContainerType || (contentBlockStyles === null || contentBlockStyles === void 0 ? void 0 : contentBlockStyles.mobileContainerType), containerType || (contentBlockStyles === null || contentBlockStyles === void 0 ? void 0 : contentBlockStyles.containerType));
    const styles = contentBlockStylesToClasses(contentBlockStyles);
    return _jsx("div", { className: `w-full h-full ${styles} ${!styles ? legacyClasses : ""}`, children: children });
};
const contentBlockStylesToClasses = (contentBlockStyles) => {
    var _a, _b, _c;
    // All responsive containerType values are in nested breakpoint objects
    const desktopClasses = responsiveClasses(((_a = contentBlockStyles.desktop) === null || _a === void 0 ? void 0 : _a.containerType) || "", DEVICE_TYPES.DESKTOP);
    const tabletClasses = responsiveClasses(((_b = contentBlockStyles.tablet) === null || _b === void 0 ? void 0 : _b.containerType) || "", DEVICE_TYPES.TABLET);
    const mobileClasses = responsiveClasses(((_c = contentBlockStyles.mobile) === null || _c === void 0 ? void 0 : _c.containerType) || "", DEVICE_TYPES.MOBILE);
    return ` ${mobileClasses} ${tabletClasses} ${desktopClasses} gap-${contentBlockStyles.containerPadding || "4"}`.trim();
};
// DEPRECEATED - use/configure the component registry instead
const legacyContainerClasses = (mobileContainerType, containerType) => {
    let mobileCardContainerTypeClassNames = "";
    if (mobileContainerType) {
        const mobileTypeParts = (mobileContainerType === null || mobileContainerType === void 0 ? void 0 : mobileContainerType.split("-").map(part => part.trim())) || [];
        const mobileMainType = mobileTypeParts[0];
        mobileCardContainerTypeClassNames += `${TAILWIND[mobileMainType] || ""} `;
        // 1 is the main type
        mobileTypeParts.slice(1).forEach(part => {
            const [value, variable] = part.split(" ");
            if (variable && value) {
                mobileCardContainerTypeClassNames += `${TAILWIND[variable] || ""}${value} `;
            }
        });
    }
    const applyToMobile = mobileCardContainerTypeClassNames.length > 0 ? true : false;
    let containerClassNames = "";
    // split the card container type by -
    const typeParts = (containerType === null || containerType === void 0 ? void 0 : containerType.split("-").map((part) => part.trim())) || [];
    const mainType = typeParts[0];
    containerClassNames += `${applyToMobile ? "md:" : ""}${TAILWIND[mainType] || ""} `;
    // 1 is the main type
    typeParts.slice(1).forEach((part) => {
        const [value, variable] = part.split(" ");
        if (variable && value) {
            containerClassNames += `${applyToMobile ? "md:" : ""}${TAILWIND[variable] || ""}${value} `;
        }
    });
    return `${mobileCardContainerTypeClassNames} ${containerClassNames}`;
};
